// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var DeviceMake_Enum;
(function (DeviceMake_Enum) {
    DeviceMake_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    DeviceMake_Enum["FAKE"] = "FAKE";
    DeviceMake_Enum["POLYCOM"] = "POLYCOM";
    DeviceMake_Enum["YEALINK"] = "YEALINK";
})(DeviceMake_Enum || (DeviceMake_Enum = {}));
export var DeviceMake_Enum_index;
(function (DeviceMake_Enum_index) {
    DeviceMake_Enum_index[DeviceMake_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    DeviceMake_Enum_index[DeviceMake_Enum_index["FAKE"] = 1] = "FAKE";
    DeviceMake_Enum_index[DeviceMake_Enum_index["POLYCOM"] = 2] = "POLYCOM";
    DeviceMake_Enum_index[DeviceMake_Enum_index["YEALINK"] = 3] = "YEALINK";
})(DeviceMake_Enum_index || (DeviceMake_Enum_index = {}));
export var DeviceInclude_Enum;
(function (DeviceInclude_Enum) {
    DeviceInclude_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    DeviceInclude_Enum["E911_ADDRESS"] = "E911_ADDRESS";
    DeviceInclude_Enum["CALL_GROUPS"] = "CALL_GROUPS";
    DeviceInclude_Enum["REGISTRATION"] = "REGISTRATION";
})(DeviceInclude_Enum || (DeviceInclude_Enum = {}));
export var DeviceInclude_Enum_index;
(function (DeviceInclude_Enum_index) {
    DeviceInclude_Enum_index[DeviceInclude_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    DeviceInclude_Enum_index[DeviceInclude_Enum_index["E911_ADDRESS"] = 1] = "E911_ADDRESS";
    DeviceInclude_Enum_index[DeviceInclude_Enum_index["CALL_GROUPS"] = 2] = "CALL_GROUPS";
    DeviceInclude_Enum_index[DeviceInclude_Enum_index["REGISTRATION"] = 3] = "REGISTRATION";
})(DeviceInclude_Enum_index || (DeviceInclude_Enum_index = {}));
export var DeviceType_Enum;
(function (DeviceType_Enum) {
    DeviceType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    DeviceType_Enum["DESK_PHONE"] = "DESK_PHONE";
    DeviceType_Enum["SOFTPHONE"] = "SOFTPHONE";
    DeviceType_Enum["MOBILE_APP"] = "MOBILE_APP";
})(DeviceType_Enum || (DeviceType_Enum = {}));
export var DeviceType_Enum_index;
(function (DeviceType_Enum_index) {
    DeviceType_Enum_index[DeviceType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    DeviceType_Enum_index[DeviceType_Enum_index["DESK_PHONE"] = 1] = "DESK_PHONE";
    DeviceType_Enum_index[DeviceType_Enum_index["SOFTPHONE"] = 2] = "SOFTPHONE";
    DeviceType_Enum_index[DeviceType_Enum_index["MOBILE_APP"] = 3] = "MOBILE_APP";
})(DeviceType_Enum_index || (DeviceType_Enum_index = {}));
export var LineKeyType_Enum;
(function (LineKeyType_Enum) {
    LineKeyType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    LineKeyType_Enum["LOCAL_CONTACT"] = "LOCAL_CONTACT";
    LineKeyType_Enum["DATA_ENDPOINT"] = "DATA_ENDPOINT";
    LineKeyType_Enum["OFFICE_EXTENSION"] = "OFFICE_EXTENSION";
    LineKeyType_Enum["PARK_SLOT"] = "PARK_SLOT";
    LineKeyType_Enum["PERSONAL_VOICEMAIL"] = "PERSONAL_VOICEMAIL";
    LineKeyType_Enum["USER_EXTENSION"] = "USER_EXTENSION";
    LineKeyType_Enum["VOICEMAIL_EXTENSION"] = "VOICEMAIL_EXTENSION";
})(LineKeyType_Enum || (LineKeyType_Enum = {}));
export var LineKeyType_Enum_index;
(function (LineKeyType_Enum_index) {
    LineKeyType_Enum_index[LineKeyType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    LineKeyType_Enum_index[LineKeyType_Enum_index["LOCAL_CONTACT"] = 1] = "LOCAL_CONTACT";
    LineKeyType_Enum_index[LineKeyType_Enum_index["DATA_ENDPOINT"] = 2] = "DATA_ENDPOINT";
    LineKeyType_Enum_index[LineKeyType_Enum_index["OFFICE_EXTENSION"] = 3] = "OFFICE_EXTENSION";
    LineKeyType_Enum_index[LineKeyType_Enum_index["PARK_SLOT"] = 4] = "PARK_SLOT";
    LineKeyType_Enum_index[LineKeyType_Enum_index["PERSONAL_VOICEMAIL"] = 5] = "PERSONAL_VOICEMAIL";
    LineKeyType_Enum_index[LineKeyType_Enum_index["USER_EXTENSION"] = 6] = "USER_EXTENSION";
    LineKeyType_Enum_index[LineKeyType_Enum_index["VOICEMAIL_EXTENSION"] = 7] = "VOICEMAIL_EXTENSION";
})(LineKeyType_Enum_index || (LineKeyType_Enum_index = {}));
export var RegistrationStatus_Enum;
(function (RegistrationStatus_Enum) {
    RegistrationStatus_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    RegistrationStatus_Enum["REGISTERED"] = "REGISTERED";
    RegistrationStatus_Enum["UNREGISTERED"] = "UNREGISTERED";
    RegistrationStatus_Enum["NEVER_REGISTERED"] = "NEVER_REGISTERED";
})(RegistrationStatus_Enum || (RegistrationStatus_Enum = {}));
export var RegistrationStatus_Enum_index;
(function (RegistrationStatus_Enum_index) {
    RegistrationStatus_Enum_index[RegistrationStatus_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RegistrationStatus_Enum_index[RegistrationStatus_Enum_index["REGISTERED"] = 1] = "REGISTERED";
    RegistrationStatus_Enum_index[RegistrationStatus_Enum_index["UNREGISTERED"] = 2] = "UNREGISTERED";
    RegistrationStatus_Enum_index[RegistrationStatus_Enum_index["NEVER_REGISTERED"] = 3] = "NEVER_REGISTERED";
})(RegistrationStatus_Enum_index || (RegistrationStatus_Enum_index = {}));
export var DeviceOwner_Enum;
(function (DeviceOwner_Enum) {
    DeviceOwner_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    DeviceOwner_Enum["WEAVE"] = "WEAVE";
    DeviceOwner_Enum["CUSTOMER"] = "CUSTOMER";
})(DeviceOwner_Enum || (DeviceOwner_Enum = {}));
export var DeviceOwner_Enum_index;
(function (DeviceOwner_Enum_index) {
    DeviceOwner_Enum_index[DeviceOwner_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    DeviceOwner_Enum_index[DeviceOwner_Enum_index["WEAVE"] = 1] = "WEAVE";
    DeviceOwner_Enum_index[DeviceOwner_Enum_index["CUSTOMER"] = 2] = "CUSTOMER";
})(DeviceOwner_Enum_index || (DeviceOwner_Enum_index = {}));
export const DevicesAPI = {
    List(fn, req) {
        return fn(`/phone/devices/v2?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetDevice(fn, req) {
        try {
            fm.validateUrlParam(req["deviceId"], "deviceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/v2/${req["deviceId"]}?${fm.renderURLSearchParams(req, ["deviceId"])}`, { method: "GET" });
    },
    UpdateDevice(fn, req) {
        var _a, _b;
        try {
            fm.validateUrlParam((_a = req["device"]) === null || _a === void 0 ? void 0 : _a["deviceId"], "device.deviceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/v2/${(_b = req["device"]) === null || _b === void 0 ? void 0 : _b["deviceId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetDeviceExtensions(fn, req) {
        try {
            fm.validateUrlParam(req["deviceId"], "deviceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/v2/${req["deviceId"]}/extensions?${fm.renderURLSearchParams(req, ["deviceId"])}`, { method: "GET" });
    },
    UpdateDeviceExtension(fn, req) {
        try {
            fm.validateUrlParam(req["deviceId"], "deviceId");
            fm.validateUrlParam(req["extensionId"], "extensionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/v2/${req["deviceId"]}/extensions/${req["extensionId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetDeviceExtensionCallGroups(fn, req) {
        try {
            fm.validateUrlParam(req["deviceId"], "deviceId");
            fm.validateUrlParam(req["extensionId"], "extensionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/v2/${req["deviceId"]}/extensions/${req["extensionId"]}/call-groups?${fm.renderURLSearchParams(req, ["deviceId", "extensionId"])}`, { method: "GET" });
    },
    ReplaceDeviceExtensionCallGroups(fn, req) {
        try {
            fm.validateUrlParam(req["deviceId"], "deviceId");
            fm.validateUrlParam(req["extensionId"], "extensionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/v2/${req["deviceId"]}/extensions/${req["extensionId"]}/call-groups`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetDeviceE911Address(fn, req) {
        try {
            fm.validateUrlParam(req["deviceId"], "deviceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/v2/${req["deviceId"]}/e911-address?${fm.renderURLSearchParams(req, ["deviceId"])}`, { method: "GET" });
    },
    UpdateDeviceE911Address(fn, req) {
        try {
            fm.validateUrlParam(req["deviceId"], "deviceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/v2/${req["deviceId"]}/e911-address`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetLineKeys(fn, req) {
        try {
            fm.validateUrlParam(req["deviceId"], "deviceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/v2/${req["deviceId"]}/line-keys?${fm.renderURLSearchParams(req, ["deviceId"])}`, { method: "GET" });
    },
    ReplaceLineKeys(fn, req) {
        try {
            fm.validateUrlParam(req["deviceId"], "deviceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/v2/${req["deviceId"]}/line-keys`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DuplicateLineKeys(fn, req) {
        try {
            fm.validateUrlParam(req["sourceDeviceId"], "sourceDeviceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/v2/${req["sourceDeviceId"]}/line-keys/duplicate`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // These RPCs occupy the same address space as GetDevice (GET /phone/devices/v2/{device_id}).
    // Because the last registered RPC that matches a path is chosen, these more specific
    // paths need to be declared after the generic {device_id} path.
    GetLineKeyOptions(fn, req) {
        return fn(`/phone/devices/v2/line-key-options?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetModels(fn, req) {
        return fn(`/phone/devices/v2/models?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    Sync(fn, req) {
        return fn(`/phone/devices/v2/sync`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
